import { track } from "../analytics";

/** Where a goon card was taken from — the closed vocabulary the dashboard breaks down by. */
export type SessionCardSource = "recap" | "profile";

/** The card left the page, by share sheet or download — once per card shown. */
export const trackSessionCardDownloaded = (source: SessionCardSource): void =>
  track("session_card_downloaded", { source });
